import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames/bind'
import Icon from '../../elementals/icon'
import Popup from '../../overlays/popup'
import TagDropdown from '../../elementals/tagDropdown'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const renderEditIcon = (propertyId, photoId) => {
  const active = _.every([propertyId, photoId], Boolean)

  const renderTrigger = () => (
    <Icon
      data-elm-id='edit_icon'
      name='pencil-alt'
      style={{ fontSize: 16, cursor: 'pointer' }}
      iconStyle='solid'
      disabled={!active}
      fitted
      color='grayLight'
      className='u-pr-1'
      hoverColor={active ? 'adcLightBlue' : ''}
      onClick={() => {
        window.location.assign(
          `/trinity/property/${propertyId}/photos/${photoId}/edit`
        )
      }}
    />
  )
  return (
    <Popup
      content='Please save this newly uploaded photo first'
      trigger={renderTrigger()}
      style={{ left: -12 }}
      disabled={active}
    />
  )
}

const formatDate = dateString => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  return dateString
    ? new Date(dateString).toLocaleDateString(undefined, options)
    : ''
}

const PhotoCard = ({
  id,
  tag = '',
  title = '',
  createdOn = '',
  updatedOn = '',
  ribbon = undefined,
  isSelected = false,
  onDelete = _.noop,
  onUndelete = _.noop,
  onDoubleClick = _.noop,
  onTagChange = _.noop,
  photoUrl = '',
  photoId = '',
  propertyId = '',
  disableTag = false,
  showPhotoOnly = false,
  allowEditing = true,
  allowTagging = true,
}) => {
  return (
    <div
      data-elm-id='photo_card'
      key={id}
      className={cx('card', {
        'photo-only': showPhotoOnly,
      })}
    >
      {!showPhotoOnly && (
        <div className={cx('header')}>
          <div className={cx('row')}>
            <div data-elm-id='title'>
              <strong>{title}</strong>
            </div>
            <div>
              {isSelected &&
                allowEditing &&
                renderEditIcon(propertyId, photoId)}
              <Icon
                data-elm-id='delete_icon'
                style={{ fontSize: 16, cursor: 'pointer' }}
                iconStyle='solid'
                name={isSelected ? 'trash' : 'trash-undo'}
                fitted
                color='grayLight'
                hoverColor={isSelected ? 'error' : 'success'}
                onClick={() => {
                  isSelected ? onDelete(id) : onUndelete(id)
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          backgroundImage: `url(${photoUrl})`,
        }}
        data-elm-id='photo'
        className={cx('photo', showPhotoOnly && ['photo-only'])}
        onDoubleClick={() => {
          onDoubleClick(id)
        }}
      >
        <div className={cx('ribbon-container')}>{ribbon}</div>
        {allowTagging && !showPhotoOnly && (
          <div className={cx('row', 'bottom-right-box')}>
            <div className={cx('tag-dropdown')}>
              <TagDropdown
                tag={tag}
                size='tiny'
                onTagChange={onTagChange(id)}
                disabled={disableTag}
                elmId={`photo_card_tag_dropdown_${id}`}
              />
            </div>
          </div>
        )}
      </div>
      {showPhotoOnly && createdOn && onDelete && (
        <div className={cx('footer')}>
          <div className={cx('row')}>
            <div className={cx('footer-subtitle')} data-elm-id='created-on'>
              Uploaded: <span>{formatDate(createdOn)}</span>
            </div>
            <Icon
              data-elm-id='delete_icon'
              style={{ fontSize: 16, cursor: 'pointer' }}
              iconStyle='solid'
              name={isSelected ? 'trash' : 'trash-undo'}
              fitted
              color='errorLight'
              hoverColor={isSelected ? 'error' : 'success'}
              onClick={() => {
                isSelected ? onDelete(id) : onUndelete(id)
              }}
              className={cx('delete-icon', { selected: isSelected })}
            />
          </div>
        </div>
      )}

      {!showPhotoOnly && (
        <div className={cx('footer')}>
          <div className={cx('row')}>
            <div className={cx('footer-subtitle')} data-elm-id='created-on'>
              Uploaded: <span>{formatDate(createdOn)}</span>
            </div>
          </div>
          <div className={cx('row')}>
            <div className={cx('footer-subtitle')} data-elm-id='updated-on'>
              Last Update:{' '}
              <span>
                {updatedOn ? formatDate(updatedOn) : formatDate(createdOn)}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

PhotoCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isSelected: PropTypes.bool,
  title: PropTypes.string,
  tag: PropTypes.string,
  createdOn: PropTypes.string,
  updatedOn: PropTypes.string,
  ribbon: PropTypes.node,
  onDelete: PropTypes.func,
  onUndelete: PropTypes.func,
  onTagChange: PropTypes.func,
  onDoubleClick: PropTypes.func,
  photoUrl: PropTypes.string,
  photoId: PropTypes.string,
  propertyId: PropTypes.string,
  disableTag: PropTypes.bool,
  showPhotoOnly: PropTypes.bool,
  allowEditing: PropTypes.bool,
  allowTagging: PropTypes.bool,
}

export default PhotoCard
